import type { SettingsPage } from "../types";

const pdfSettings: SettingsPage = {
  id: "pdf",
  label: "PDF",
  order: 2,
  items: [
    {
      key: "zoomHeading",
      label: "Zoom",
      type: "heading",
      default: "",
    },
    {
      key: "defaultZoom",
      label: "Default zoom level",
      type: "number",
      default: 1.5,
      min: 0.5,
      max: 3,
      step: 0.25,
      description: "Zoom a PDF document opens at (150% = 1.5), and what \"Reset zoom\" returns to.",
    },
    {
      key: "zoomStep",
      label: "Zoom step",
      type: "number",
      default: 0.25,
      min: 0.05,
      max: 1,
      step: 0.05,
      description: "How much each zoom in/out click changes the zoom level.",
    },
  ],
};

export default pdfSettings;
